import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { RESET_PASSWORD } from 'src/apiService/apiDeclaration';
import Wrapper from 'src/components/common/wrapper';
import CustomTextField from 'src/components/formFields/textField';
import LoaderButton from 'src/components/loaderButton/loaderButton';
import { resetPasswordSchema } from 'src/config/yup';
import { showSuccessTost } from 'src/constants';
import { removeData } from 'src/helper/storageHelper';

const SetNewPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(resetPasswordSchema.omit(['currentPass'])),
  });
  const setPassword = async (body) => {
    setLoading(true);
    try {
      const resp = await RESET_PASSWORD(body);
      removeData('token');
      navigate('/');
      showSuccessTost(resp.message);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Wrapper>
      <Helmet>
        <title>Set New Password</title>
      </Helmet>
      <Typography sx={{ mb: 3 }} variant="h4" color={'primary'}>
        {t('setNewPasswordPage.heading')}
      </Typography>
      <Box sx={{ width: '100%', margin: '0 auto' }}>
        <form onSubmit={handleSubmit(setPassword)}>
          <Grid sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Grid item xs={12}>
              <CustomTextField
                label={t('resetPasswordPage.newPass')}
                type="password"
                isPassword
                controller={{
                  name: 'password',
                  control: control,
                  errors: errors.password,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomTextField
                label={t('common.confirmPassword')}
                type="password"
                isPassword
                controller={{
                  name: 'confirmPassword',
                  control: control,
                  errors: errors.confirmPassword,
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ mt: 2 }}>
              <LoaderButton
                type="password"
                loading={loading}
                variant="contained"
                disabled={!isValid}
                buttonText={t('setNewPasswordPage.setPass')}
              />
            </Grid>
          </Grid>
        </form>
      </Box>
    </Wrapper>
  );
};

export default SetNewPassword;
